import Default from "../Pages/Dashboard/Default/Default";
import LockerAssign from "../Pages/SamplePage/LockerAssign";
import AllLockerAssign from "../Pages/Application/Master/book_ticket/AllLockerAssign";
import AccountProfile from "../Pages/SamplePage/AccountProfile";
import AccountSettings from "../Pages/SamplePage/AccountSettings";
import LockerInvoice from "../Pages/Application/Master/book_ticket/LockerInvoice";


const lockerCRoutes = [
  // dashboard
  { path: `${process.env.PUBLIC_URL}/dashboard/default`, Component: <Default /> },

  // Account
   { path: `${process.env.PUBLIC_URL}/account/account_settings`, Component: <AccountSettings /> },
   { path: `${process.env.PUBLIC_URL}/account/account_profile`, Component: <AccountProfile /> },
   { path: `${process.env.PUBLIC_URL}/locker/locker_assign`, Component: <LockerAssign /> },
   { path: `${process.env.PUBLIC_URL}/locker/all_locker_assign`, Component: <AllLockerAssign/> },
   { path: `${process.env.PUBLIC_URL}/print-locker-invoice/:id`, Component: <LockerInvoice /> },
];

export default lockerCRoutes;
